import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { keyframes } from 'tss-react';

const spinLoaderAfter = keyframes({
  '0%': {
    transform: 'rotate(45deg)',
    WebkitTransform: 'rotate(45deg)',
  },
  '100%': {
    transform: 'rotate(405deg)',
    WebkitTransform: 'rotate(405deg)',
  },
});

const spinLoaderBefore = keyframes({
  '0%': {
    transform: 'rotate(75deg)',
    WebkitTransform: 'rotate(75deg)',
  },
  '100%': {
    transform: 'rotate(435deg)',
    WebkitTransform: 'rotate(435deg)',
  },
});
export const useStyles = makeStyles<{ theme: Theme }>()((theme) => ({
  progressWrapper: {
    right: '50%',
    left: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loading: {
    position: 'sticky',
    top: '45%',
  },
  loaded: {
    position: 'sticky',
    top: '50%',
  },
  loadedInPopup: { transform: 'translateY(-50%)' },
  progressText: {
    paddingBottom: theme.spacing(1),
  },
  backdrop: {
    display: 'block',
    position: 'absolute',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    color: theme.palette.grey[700],
    zIndex: 5,
  },
  loader: {
    position: 'relative',
    minHeight: '9rem',
    '&:before': {
      content: '""',
      display: 'block',
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      position: 'absolute',
      left: '50%',
      top: '50%',
      margin: 'calc(-25px) 0 0 calc(-25px)',
      backgroundClip: 'padding-box',
      animation: `${spinLoaderBefore} 2s infinite linear`,
      WebkitAnimationName: `${spinLoaderBefore}`,
      WebkitAnimationDuration: '2s',
      WebkitAnimationTimingFunction: 'linear',
      WebkitAnimationIterationCount: 'infinite',
      zIndex: 3,
      borderRight: '2px solid #383838',
      borderBottom: '2px solid #D6D4D2',
      borderLeft: '2px solid #D6D4D2',
      borderTop: '2px solid rgba(56, 56, 56, 0.8)',
    },
    '&:after': {
      content: '""',
      display: 'block',
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      position: 'absolute',
      left: '50%',
      top: '50%',
      marginLeft: 'calc(-25px)',
      marginTop: 'calc(-25px)',
      backgroundClip: 'padding-box',
      borderBottom: '2px solid transparent',
      borderLeft: '2px solid transparent',
      animation: `${spinLoaderAfter} 2s infinite linear`,
      WebkitAnimationName: `${spinLoaderAfter}`,
      WebkitAnimationDuration: '2s',
      WebkitAnimationTimingFunction: 'linear',
      WebkitAnimationIterationCount: 'infinite',
      zIndex: 4,
      borderTop: '2px solid #383838',
      borderRight: '1px solid rgba(56, 56, 56, 0.8)',
      WebkitBoxShadow: '1px -1px 1px #383838',
      boxShadow: '1px -1px 1px #383838',
    },
  },
  additionalInfo: {
    position: 'sticky',
    width: '300px',
    textAlign: 'center',
    top: '120px',
    marginBottom: '10px',
  },
}));
